import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  darkMode = signal<boolean>(false);

  constructor() {
    const stored = localStorage.getItem('kds_dark_mode');
    const isDark = stored === null ? true : stored === 'true';
    this.darkMode.set(isDark);
    this.applyDarkMode(isDark);
  }

  toggleDarkMode() {
    const next = !this.darkMode();
    this.darkMode.set(next);
    this.applyDarkMode(next);
    localStorage.setItem('kds_dark_mode', String(next));
  }

  private applyDarkMode(enabled: boolean) {
    const html = document.documentElement;
    if (enabled) {
      html.classList.add('dark');
    } else {
      html.classList.remove('dark');
    }
  }
}